import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import { FileUpload } from "primereact/fileupload";
import {
  CustomCalendar,
  CustomCheckbox,
  CustomDropDown,
  CustomFileInput,
  CustomInput,
  CustomTextArea,
} from "shared/components/allInput";
import UploadIcon from "assets/icons/pinupload.svg";
import { toast } from "react-toastify";
import formValidation from "utils/validations";
import {
  accountingOption,
  checkboxOptions,
  ClausesOptions,
  servicesOption,
} from "shared/components/AllDropdownOptions";
import { useState } from "react";

const ProducerTerms = ({ data, setData }) => {
  console.log("data", data);
  const [checkedItems, setCheckedItems] = useState([]);
  // const [file, setFile] = useState(null);

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data);
    setData((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const handleDateChange = (e) => {
    setData((prev) => ({
      ...prev,
      [e.name]: e.value,
    }));
  };

  // const handleFileUpload = (event) => {
  //   const uploadedFile = event.files[0];
  //   if (uploadedFile) {
  //     setData((prev) => ({ ...prev, document: uploadedFile }));
  //   }
  // };

  const handleCheckboxChange = (name, isChecked) => {
    setData((prev) => {
      const currentClauses = [...(prev.clauses || [])];

      if (name === "remedies") {
        if (isChecked) {
          // Add to clauses (but without a value)
          if (!currentClauses.some((item) => item.name === name)) {
            currentClauses.push({ name });
          }
          // Initialize remedies object
          return {
            ...prev,
            clauses: currentClauses,
            remedies: {
              jurisdiction: "",
              procedure: "",
              preagreedCompensation: "",
            },
          };
        } else {
          // Remove from clauses and clear remedies
          const index = currentClauses.findIndex((item) => item.name === name);
          if (index !== -1) currentClauses.splice(index, 1);
          return { ...prev, clauses: currentClauses, remedies: null };
        }
      } else {
        // Normal clause (add/remove with value)
        if (isChecked) {
          if (!currentClauses.some((item) => item.name === name)) {
            currentClauses.push({ name, value: "" });
          }
        } else {
          const index = currentClauses.findIndex((item) => item.name === name);
          if (index !== -1) currentClauses.splice(index, 1);
        }
        return { ...prev, clauses: currentClauses };
      }
    });
  };

  // const handleFileChange = (event) => {
  //   const selectedFile = event.target.files[0];
  //   setFile(selectedFile);
  // };

  // const handleDeleteFile = () => {
  //   setFile(null);
  // };

  return (
    <>
      <div className="w-6">
        {/* <h4 className="text-xl">(optional) Upload an Agreement</h4>
        <p className="py-3">
          Please upload a copy of the agreement for verification.
        </p>
        {file && (
          <div className="flex align-items-center gap-2">
            <img src={UploadIcon} alt="Upload Icon" />
            <span>{file.name}</span>
            <button onClick={handleDeleteFile} className="text-red-500 ml-2">
              X
            </button>
          </div>
        )}
        <CustomFileInput
          name="document"
          onChange={handleFileChange}
          ignoreLabel
        /> */}
        <h4 className="text-xl">Draft an Agreement</h4>
        <CustomInput
          data={data}
          name="agreementName"
          label="Name of Agreement"
          ignoreLabel
          col={12}
          onChange={handleChange}
        />
      </div>
      <div>
        <h5 className="text-xl font-medium">Primary Artist Name</h5>
        <div className="grid mt-3 align-items-center">
          <div className="md:col-5">
            <label className="text-gray-500" htmlFor="">
              Artist Full Legal Name
            </label>
            <CustomInput
              name="fullLegalName"
              data={data}
              ignoreLabel
              col={12}
              onChange={handleChange}
            />
          </div>
          <div className="col text-center">p/k/a</div>
          <div className="md:col-5">
            <label className="text-gray-500" htmlFor="">
              Artist Name
            </label>
            <CustomInput
              data={data}
              ignoreLabel
              name="name"
              onChange={handleChange}
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Primary Artist Address</h5>
            <label className="text-gray-500" htmlFor="">
              Unit Number, Street Number, City, State, Zip Code
            </label>
            <CustomTextArea
              col={12}
              className="w-full mt-3"
              rows={5}
              cols={30}
              data={data}
              ignoreLabel
              name="address"
              onChange={handleChange}
            />
          </div>
          <div className="md:col-6">
            <h5 className="text-xl font-medium mb-3"> Producer Name</h5>
            <CustomInput
              data={data}
              name="producerName"
              ignoreLabel
              onChange={handleChange}
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">
              Producer Artist Address
            </h5>
            <label className="text-gray-500" htmlFor="">
              Unit Number, Street Number, City, State, Zip Code
            </label>
            <CustomTextArea
              className="w-full mt-3"
              rows={5}
              col={12}
              cols={30}
              data={data}
              name="producerAddress"
              onChange={handleChange}
              ignoreLabel
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Scope of Services</h5>
            <label className="text-gray-500" htmlFor="">
              Example: Mixing and mastering; mixing only; or mastering only
            </label>
            <CustomDropDown
              options={servicesOption}
              data={data}
              optionLabel="name"
              name="services"
              onChange={handleChange}
              ignoreLabel
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Track Title</h5>
            <CustomInput
              data={data}
              name="trackName"
              onChange={handleChange}
              ignoreLabel
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Edits and Approval</h5>
            <p className="mb-2">
              Describe how the workflow and approval process will be.
            </p>
            <label className="text-gray-500" htmlFor="">
              Example: There will be no more than [3] major edits and
              [unlimited] minor edits. Final edit to be approved by the Artist.
            </label>
            <CustomInput
              data={data}
              name="approvalProcess"
              onChange={handleChange}
              ignoreLabel
            />
            <CustomInput
              data={data}
              name="workflow"
              onChange={handleChange}
              ignoreLabel
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Delivery Method</h5>
            <p className="mb-2">
              Describe how the producer will deliver the production work.
            </p>
            <label className="text-gray-500" htmlFor="">
              Example: all stems, additional edits, and instrumental versions
              made in connection with the Recording.
            </label>
            <CustomInput
              data={data}
              name="deliveryMethod"
              onChange={handleChange}
              ignoreLabel
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Deadline</h5>
            <p className="mb-2">Add any deadline(s).</p>
            <CustomCalendar
              data={data}
              name="deadline"
              value={data?.deadline ? new Date(data.deadline) : null}
              ignoreLabel
              onChange={handleDateChange}
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Fee</h5>
            <p className="mb-2">Add a Fee. Write 'NA' if not available.</p>
            <CustomInput
              data={data}
              name="fee"
              onChange={handleChange}
              ignoreLabel
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Master Royalty Split</h5>
            <p className="mb-2">
              Add Master Royalty Split.Write 'NA' if not available.
            </p>
            <CustomInput
              data={data}
              name="masterRoyalty"
              onChange={handleChange}
              ignoreLabel
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">
              Review Recoupability Clause
            </h5>
            <CustomInput
              data={data}
              name="recoupabilityClause"
              onChange={handleChange}
              ignoreLabel
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Credit</h5>
            <p className="mb-2">
              Describe how the producer will be credited in the track.
            </p>
            <label className="text-gray-500" htmlFor="">
              Example: Jayne "Forestry ft. Sagee" or “Produced by Sagee”
            </label>
            <CustomInput
              data={data}
              name="credit"
              onChange={handleChange}
              ignoreLabel
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Accounting</h5>
            <p className="mb-2">
              Choose how the royalty will be accounted. Choose NA if not
              available.
            </p>
            <CustomDropDown
              options={accountingOption}
              ignoreLabel
              data={data}
              name="accountingType"
              onChange={handleChange}
              optionLabel="name"
              value={data.accountingType}
            />

            <CustomInput
              data={data}
              name="accountingCost"
              onChange={handleChange}
              ignoreLabel
              disabled={!data?.accountingType || data?.accountingType === "na"}
            />

            <CustomInput
              data={data}
              name="accountingDispute"
              onChange={handleChange}
              ignoreLabel
              disabled={!data?.accountingType || data?.accountingType === "na"}
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">
              Other Clauses to Add/Consider
            </h5>
            <p className="mb-2">
              Add any clauses that may be needed for your contract.
            </p>

            {ClausesOptions.map((item) => {
              const isChecked = data.clauses?.some((c) => c.name === item.name) ?? false;
              // console.log("isss", isChecked)
              return (
                <div key={item.name}>
                  <CustomCheckbox
                    name={item.name}
                    label={item.label}
                    checked={isChecked}
                    onChange={({ name, value }) =>
                      handleCheckboxChange(name, value)
                    }
                  />

                  {/* Remedies inputs */}
                  {item.name === "remedies" &&
                    isChecked &&
                    data.clauses?.some((c) => c.name === "remedies") && (
                      <div className="remedies-inputs">
                        <CustomInput
                          data={data}
                          name="preagreedCompensation"
                          onChange={({ name, value }) => {
                            setData((prev) => ({
                              ...prev,
                              remedies: {
                                ...prev.remedies,
                                preagreedCompensation: value,
                              },
                            }));
                          }}
                          placeholder="Enter agreed compensation..."
                          ignoreLabel
                        />
                        <CustomInput
                          data={data}
                          name="jurisdiction"
                          onChange={({ name, value }) => {
                            setData((prev) => ({
                              ...prev,
                              remedies: {
                                ...prev.remedies,
                                jurisdiction: value,
                              },
                            }));
                          }}
                          placeholder="Enter jurisdiction..."
                          ignoreLabel
                        />
                        <CustomInput
                          data={data}
                          name="procedure"
                          onChange={({ name, value }) => {
                            setData((prev) => ({
                              ...prev,
                              remedies: { ...prev.remedies, procedure: value },
                            }));
                          }}
                          placeholder="Enter procedure..."
                          ignoreLabel
                        />
                      </div>
                    )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProducerTerms;
